import { store } from '@/store';
import {
  DASHBOARD_PERMISSIONS,
  COMPANY_PERMISSIONS,
  CUSTOMER_PERMISSIONS,
  LOAN_PERMISSIONS,
  INVESTMENT_PERMISSIONS,
  PAYMENT_PERMISSIONS,
  STAFF_PERMISSIONS,
  PARTNER_PERMISSIONS,
  CORPORATE_PERMISSIONS,
  WALLET_PERMISSIONS,
  REPORT_PERMISSIONS,
  LOAN_CONFIG_PERMISSIONS,
  PARTNER_AUTH_PERMISSIONS,
  PUSH_NOTIFICATION_PERMISSIONS,
  FEEDBACK_PERMISSIONS,
} from '@/constants/permissions';

export const FEEDBACK_ACCESS_GROUPS = {
  PRODUCT: ['Product Team', 'Product'],
  FULFILLMENT: ['Customer Fulfillment Team', 'Customer Fulfillment'],
  CGO: ['CGO'],
};

export const hasPermission = (requiredPermissions, requireAll = true) => {
  // return true; // Just uncomment to test

  const userPermissions = store.getters['auth/currentUser']?.permissions || [];

  if (!requiredPermissions) return true;

  if (Array.isArray(requiredPermissions)) {
    return requireAll
      ? requiredPermissions.every((permission) => userPermissions.includes(permission)) // ALL required
      : requiredPermissions.some((permission) => userPermissions.includes(permission)); // ANY ONE required
  }

  return userPermissions.includes(requiredPermissions);
};

export const getCurrentUserGroups = () => {
  const groups = store.getters['auth/currentUser']?.groups || [];
  return groups
    .map((group) => (typeof group === 'string' ? group : group?.type || group?.name || ''))
    .filter(Boolean);
};

export const hasStaffGroup = (groupNames = []) => {
  const userGroups = getCurrentUserGroups();
  return groupNames.some((name) => userGroups.includes(name));
};

export const canViewFeedbackTrends = () =>
  hasPermission(FEEDBACK_PERMISSIONS.VIEW_TRENDS) ||
  hasStaffGroup([...FEEDBACK_ACCESS_GROUPS.PRODUCT, ...FEEDBACK_ACCESS_GROUPS.CGO]);

export const canManageFeedback = () =>
  hasPermission(FEEDBACK_PERMISSIONS.MANAGE) ||
  hasStaffGroup([...FEEDBACK_ACCESS_GROUPS.FULFILLMENT, ...FEEDBACK_ACCESS_GROUPS.CGO]);

export const canViewFeedback = () => canViewFeedbackTrends() || canManageFeedback();

// Helper function to get all permissions
export const getAllPermissions = () => ({
  ...DASHBOARD_PERMISSIONS,
  ...COMPANY_PERMISSIONS,
  ...CUSTOMER_PERMISSIONS,
  ...LOAN_PERMISSIONS,
  ...INVESTMENT_PERMISSIONS,
  ...PAYMENT_PERMISSIONS,
  ...STAFF_PERMISSIONS,
  ...PARTNER_PERMISSIONS,
  ...CORPORATE_PERMISSIONS,
  ...WALLET_PERMISSIONS,
  ...REPORT_PERMISSIONS,
  ...LOAN_CONFIG_PERMISSIONS,
  ...PARTNER_AUTH_PERMISSIONS,
  ...PUSH_NOTIFICATION_PERMISSIONS,
  ...FEEDBACK_PERMISSIONS,
});
